import React, { useState } from "react";

export default function StrandsTable() {
  // Initial mock data for strands
  const [strands, setStrands] = useState([
    { id: 1, name: "STEM", description: "Science, Technology, Engineering, and Mathematics" },
    { id: 2, name: "ABM", description: "Accountancy, Business, and Management" },
    { id: 3, name: "HUMSS", description: "Humanities and Social Sciences" },
    { id: 4, name: "GAS", description: "General Academic Strand" },
  ]);

  // State for new strand form
  const [newStrand, setNewStrand] = useState({ name: "", description: "" });

  // Add new strand
  const handleAddStrand = (e) => {
    e.preventDefault();
    if (!newStrand.name.trim()) return;
    setStrands([
      ...strands,
      { id: Date.now(), name: newStrand.name, description: newStrand.description },
    ]);
    setNewStrand({ name: "", description: "" });
  };

  // Edit strand
  const handleEditStrand = (id, updatedStrand) => {
    setStrands(strands.map(s => (s.id === id ? { ...s, ...updatedStrand } : s)));
  };

  // Delete strand
  const handleDeleteStrand = (id) => {
    setStrands(strands.filter(s => s.id !== id));
  };

  // Inline edit state
  const [editId, setEditId] = useState(null);
  const [editStrand, setEditStrand] = useState({ name: "", description: "" });

  return (
    <div>
      <form className="mb-4" onSubmit={handleAddStrand} style={{ display: "flex", gap: 8 }}>
        <input
          className="form-control"
          style={{ maxWidth: 180 }}
          type="text"
          placeholder="Strand Name"
          value={newStrand.name}
          onChange={e => setNewStrand({ ...newStrand, name: e.target.value })}
          required
        />
        <input
          className="form-control"
          style={{ maxWidth: 320 }}
          type="text"
          placeholder="Description"
          value={newStrand.description}
          onChange={e => setNewStrand({ ...newStrand, description: e.target.value })}
        />
        <button className="btn btn-success" type="submit">Add Strand</button>
      </form>
      <table className="table table-bordered table-striped">
        <thead>
          <tr>
            <th>Name</th>
            <th>Description</th>
            <th style={{ width: 120 }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {strands.map(strand => (
            <tr key={strand.id}>
              <td>
                {editId === strand.id ? (
                  <input
                    className="form-control"
                    value={editStrand.name}
                    onChange={e => setEditStrand({ ...editStrand, name: e.target.value })}
                  />
                ) : (
                  strand.name
                )}
              </td>
              <td>
                {editId === strand.id ? (
                  <input
                    className="form-control"
                    value={editStrand.description}
                    onChange={e => setEditStrand({ ...editStrand, description: e.target.value })}
                  />
                ) : (
                  strand.description
                )}
              </td>
              <td>
                {editId === strand.id ? (
                  <>
                    <button
                      className="btn btn-primary btn-sm me-2"
                      onClick={() => {
                        handleEditStrand(strand.id, editStrand);
                        setEditId(null);
                      }}
                    >Save</button>
                    <button
                      className="btn btn-secondary btn-sm"
                      onClick={() => setEditId(null)}
                    >Cancel</button>
                  </>
                ) : (
                  <>
                    <button
                      className="btn btn-warning btn-sm me-2"
                      onClick={() => {
                        setEditId(strand.id);
                        setEditStrand({ name: strand.name, description: strand.description });
                      }}
                    >Edit</button>
                    <button
                      className="btn btn-danger btn-sm"
                      onClick={() => handleDeleteStrand(strand.id)}
                    >Delete</button>
                  </>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}